export interface IArchiveDocumentRequest {
        documentKey: string;
        key: any;
        type: string;
    }

    export class ArchiveDocumentRequest implements IArchiveDocumentRequest {
        documentKey: string;
        key: any;
        type: string;

        constructor(documentKey: string, key: any, type: string) {
            this.documentKey = documentKey;
            this.key = key;
            this.type = type;
        }
    }